@switch (layout()) {
  <!-- Single job: a flat Parameter | Value table. -->
  @case ("single") {
    <div class="xwai-table">
      @if (job(); as j) {
        <div class="table-title" [title]="j.name">{{ j.name }}</div>
      }
      <nz-table
        #paramTable
        nzSize="small"
        nzBordered
        [nzData]="paramRows()"
        [nzScroll]="{ y: '420px' }"
        [nzShowPagination]="false"
        [nzFrontPagination]="false"
      >
        <thead>
          <tr>
            <th nzLeft class="param-col">Parameter</th>
            <th class="value-col">Value</th>
          </tr>
        </thead>
        <tbody>
          @for (row of paramTable.data; track row.name) {
            <tr>
              <td nzLeft class="param-col param-name">{{ row.name | replaceUnderscore }}</td>
              <td class="value-cell">{{ row.value }}</td>
            </tr>
          }
        </tbody>
      </nz-table>
    </div>
  }

  <!-- Matrix: jobs down the side, one column per parameter.
       Emitted as either "table" or "comparison". -->
  @case ("matrix") {
    <div class="xwai-table">
      <nz-table
        #cmpTable
        nzSize="small"
        nzBordered
        [nzData]="jobs()"
        [nzScroll]="{ x: scrollX(), y: '420px' }"
        [nzShowPagination]="false"
        [nzFrontPagination]="false"
      >
        <thead>
          <tr>
            <th nzLeft class="param-col">Job</th>
            @for (row of rows(); track row.name) {
              <th [nzEllipsis]="true" class="job-col" [title]="row.name | replaceUnderscore">{{ row.name | replaceUnderscore }}</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (j of cmpTable.data; track j.id) {
            <tr>
              <td nzLeft class="param-col param-name" [nzEllipsis]="true" [title]="j.name">{{ j.name }}</td>
              @for (row of rows(); track row.name) {
                <td class="value-cell" [nzEllipsis]="true" [title]="cell(row, j.id)">{{ cell(row, j.id) }}</td>
              }
            </tr>
          }
        </tbody>
      </nz-table>
    </div>
  }

  <!-- Pair: a two-job matrix transposed — parameters down the side,
       one column per job. -->
  @case ("pair") {
    <div class="xwai-table">
      <nz-table
        #pairTable
        nzSize="small"
        nzBordered
        [nzData]="rows()"
        [nzScroll]="{ y: '420px' }"
        [nzShowPagination]="false"
        [nzFrontPagination]="false"
      >
        <thead>
          <tr>
            <th nzLeft class="param-col">Parameter</th>
            @for (j of jobs(); track j.id) {
              <th [nzEllipsis]="true" [title]="j.name">{{ j.name }}</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (row of pairTable.data; track row.name) {
            <tr>
              <td nzLeft class="param-col param-name" [title]="row.name | replaceUnderscore">{{ row.name | replaceUnderscore }}</td>
              @for (j of jobs(); track j.id) {
                <td [title]="cell(row, j.id)">{{ cell(row, j.id) }}</td>
              }
            </tr>
          }
        </tbody>
      </nz-table>
    </div>
  }

  <!-- Unknown table type: show the raw payload so nothing is silently dropped. -->
  @default {
    <pre class="xwai-table-unknown">{{ raw() | json }}</pre>
  }
}
